/**
 * @package Form
 * @author Francesco Costa
 */

// fields
import {
    selectAll,
    addToList,
    removeFromList,
    togglePageSelector,
    removeElement,
    removeNewMembers,
    selectElement,
    selectGroup,
    selectPerson,
    addAll
} from './fields/list.js';
import * as fileupload from './fields/multifilesupload.js';
import * as subs from './fields/subs.js';
import * as multisubs from './fields/multisubs.js';
import initSelects from './fields/selects.js';

import initPickers from './fields/pickers.js';
import waitForSelect from './fields/waitForSelect.js';
import showOnInitiator from "./fields/showon";
import doc_ready from "document-ready";
import {hashCode, toggleFieldset, printXLS} from './util.js';
import AppliedFormFilter from "../adminbau/AppliedFormFilter";

/**
 * AdminBau Form Class
 *
 * Manage all type of form and field in the component.
 *
 * This class is not a real class: it is a container for all the things that was done in the years. This is here to
 * help the transition from old js to new one.
 *
 * @author Francesco Costa
 */
export default class AsdForm {

    static init() {
        if (window.AsdForm) {
            console.log('No multiple instance allowed');
            return;
        }
        new AsdForm();
    }

    constructor() {

        if (window.AsdForm) {
            console.log('No multiple instance allowed');
            return;
        }
        window.AsdForm = this;

        AsdForm._globals();
        doc_ready(AsdForm._docReady);
    }

    static _docReady() {
        if (!window.AsdForm) {
            return false;
        }

        initSelects();
        waitForSelect();
        showOnInitiator();
        subs.subInit();
        initPickers('flatpickr');
        fileupload.Init();

        // TODO enable when finished: WIP
        // AppliedFormFilter.init();
        // setTimeout( AppliedFormFilter.init, 1500);
    }

    static _globals() {
        window.printXLS = printXLS
        window.hashCode = hashCode;
        window.toggleFieldset = toggleFieldset;

        window.selectAll = selectAll;
        window.addToList = addToList;
        window.removeFromList = removeFromList;
        window.togglePageSelector = togglePageSelector;
        window.removeElement = removeElement;
        window.removeNewMembers = removeNewMembers;
        window.selectElement = selectElement;
        window.selectGroup = selectGroup;
        window.selectPerson = selectPerson;
        window.addAll = addAll;
        window.addFiles = fileupload.addFiles;
        window.createRow = fileupload.createRow;
        window.deleteFile = fileupload.deleteFile;
        window.deleteUpdateFile = fileupload.deleteUpdateFile;
        window.updateFile = fileupload.updateFile;
        window.removeHighlightCat = subs.removeHighlightCat;
        window.showSub = multisubs.showSub;
        window.addCat = multisubs.addCat;
        window.addCatAndSub = multisubs.addCatAndSub;
        window.removeCatAndSub = multisubs.removeCatAndSub;
        window.removeCat = (id, target) => {
            try {
                multisubs.removeCat(id, target);
            } catch (e) {
                console.log('multisubs exception: ', e);
            }
            try {
                subs.removeCat(id, target);
            } catch (e) {
                console.log('subs exception: ', e);
            }
        };
    }
}
